export const getDeepLink = (url: string, chainId = 1) => {
  const base = 'bnc://app.binance.com/mp/app'
  const appId = 'yFK5FCqYprrXDiVFbhyRx7'

  const startPagePath = window.btoa('/pages/browser/index')
  const startPageQuery = window.btoa(`url=${url}&defaultChainId=${chainId}`)
  const deeplink = `${base}?appId=${appId}&startPagePath=${startPagePath}&startPageQuery=${startPageQuery}`
  const dp = window.btoa(deeplink)
  const http = `https://app.binance.com/en/download?_dp=${dp}`
  return { http, bnc: deeplink }
}
